export default __webpack_public_path__ + "assets/apple-icon-114x114.c3872433eb0da5d7744e0cadcb772543.png";